module.exports = "/_next/static/images/Medicare-Bob_hero_header-3817b242567a9cc4384734f36adb8f15.jpeg";